<script setup lang="ts">
import { useElementId } from '../../common/composables/useElementId';
import DescriptionIcon from '../../common/components/DescriptionIcon.vue';
import { InputGroup, InputNumber, InputGroupAddon, Message, Button } from 'primevue';

interface ActionButton {
  label?: string
  icon?: string
  action: () => void
}


const props = defineProps<{
  title: string;
  changed: boolean;
  description?: string;
  error?: string;
  unit?: string;
  maxFractionDigits?: number;
  actionButton?: ActionButton
}>();

const modelValue = defineModel<number|undefined>({ required: true });

const elementId = useElementId();

</script>

<template>
  <div class="field" :class="{ changed: props.changed }">
    <div class="field-header">
      <label :for="elementId">{{ props.title }}</label>
      <DescriptionIcon v-if="props.description" :description="props.description"></DescriptionIcon>
    </div>
    <InputGroup>
      <Button v-if="actionButton" :label="actionButton.label" :icon="actionButton.icon" @click="actionButton.action" />
      <InputNumber :maxFractionDigits="props.maxFractionDigits"
        :invalid="props.error !== undefined"
        pt:pcInputText:root:autocomplete="off"
        v-model:modelValue="modelValue"
        :id="elementId"></InputNumber>
      <InputGroupAddon v-if="props.unit">{{ props.unit }}</InputGroupAddon>
    </InputGroup>
    <Message v-if="props.error" severity="error" variant="simple">{{ props.error }}</Message>
  </div>
</template>
